<template>
  <div class="component-content configuration-colour">
    <div class="component-content-scroll">
    <div class="uppercase xs-text bold mb-4">
      Select your colour details
    </div>
    <div
      class="xs-text uppercase xs-content mb-3"
      v-if="this.results.colour.type == null"
    >
      There are three ways to configure the colour scheme of your passoni
    </div>

    <option-list
      :options="getOptions()"
      :inputName="'colourType'"
      :target="this.results.colour.type"
      v-on:target-updated="updateData"
      v-if="this.results.colour.type == null"
    ></option-list>

    <component
      v-bind:is="getContent"
      :results="results"
      :primaryColor="this.results.colour.primaryColor"
      :secondaryColor="this.results.colour.secondaryColor"
      :colors="colors"
      :currentTab="currentTab"
      :bikeId="bikeConfiguration[0].bike_id"
      v-on:set-primary-color="setPrimaryColor"
      v-on:set-secondary-color="setSecondaryColor"
      v-on:current-substep="updateSubstep"
    ></component>
    </div>
    <div class="buttonset">
      <button class="btn btn-outline-dark back-button" v-on:click="goBack">
        back
      </button>
      <button class="btn btn-outline-dark next-button" v-on:click="goNext">
        next
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import OptionList from "../../shared/optionList.vue";

import officialColorsTab from "./sub-components/color-official-colors.vue";
import bespokeColorsTab from "./sub-components/color-bespoke-colors.vue";
import customColorsTab from "./sub-components/color-custom-colors.vue";

import colorPicker from "./sub-components/color-picker.vue";

Vue.component("color-picker", colorPicker);

Vue.component("color-official-colors", officialColorsTab);
Vue.component("color-bespoke-colors", bespokeColorsTab);
Vue.component("color-custom-colors", customColorsTab);

export default {
  name: "configuration-colour",
  data() {
    return {
      subSteps: [
        {
          name: "color-officials",
          template: "color-official-colors",
        },
        {
          name: "color-bespoke",
          template: "color-bespoke-colors",
        },
        {
          name: "color-custom",
          template: "color-custom-colors",
        },
      ],
      currentTab: 0,
      totalTabs: this.bikeConfiguration[0].bike_id != 23 && this.bikeConfiguration[0].bike_id != 20 ? 2 : 1,
    };
  },
  components: {
    OptionList,
  },
  computed: {
    getContent: function () {
      if (this.results.colour.type != null) {
        if (this.results.colour.type.id == 991) {
          return "color-official-colors";
        }
        if (this.results.colour.type.id == 992) {
          return "color-bespoke-colors";
        }
        if (this.results.colour.type.id == 993) {
          return "color-custom-colors";
        }
      }
      return null;
    },
  },
  props: ["configuratorSteps", "results", "currentStep", "colors", "bikeConfiguration"],
  methods: {
    getOptions: function () {
      return [
        {
          id: 991,
          name: "Official Passoni colours",
          price: 0,
          description: "",
        },
        {
          id: 992,
          name: "Bespoke colours",
          price: 500,
          description: "",
        },
        {
          id: 993,
          name: "Full custom paintwork",
          price: 1000,
          description: "",
        },
      ];
    },
    goNext: function () {
      if (this.results.colour.type == null) {
        this.$emit("set-error", "Select a color type");
      } else {
        if (
          this.results.colour.type.id == 991 ||
          this.results.colour.type.id == 992
        ) {
          if (this.results.colour.primaryColor==null) {
            this.$emit("set-error", "Select a color primary colour");
            return false;
          }

          if (this.bikeConfiguration[0].bike_id != 23 && this.bikeConfiguration[0].bike_id != 20){
            if (this.results.colour.secondaryColor==null && this.currentTab == 1) {
              this.$emit("set-error", "Select a color secondary colour");
              return false;
            }
          }

          if (this.currentTab<this.totalTabs-1) {
            this.currentTab++;
          } else {
            this.$emit("go-next");
          }



        } else {
          this.$emit("go-next");
        }
      }
    },
    goBack: function () {

      if (this.currentTab>0) {
        this.currentTab--;
        return false;
      }
      
      if (this.officialSubStep == 1 && (this.bikeConfiguration[0].bike_id != 23 && this.bikeConfiguration[0].bike_id != 20)){
        this.officialSubStep--;
        return false;
      }

      if (this.results.colour.type == null) {
        this.$emit("go-back");
      } else {
        this.$emit("set-colour-type", null);
      }

    },
    setPrimaryColor: function (e) {
      this.$emit("set-primary-color", e);
    },
    setSecondaryColor: function (e) {
      this.$emit("set-secondary-color", e);
    },
    updateData: function (e) {
      this.$emit("set-colour-type", e);
    },
    updateSubstep: function(e){
      this.currentTab = e;
    }
  },
};
</script>

<style lang="scss" scoped>
.configuration-colour {
}
</style>

